import { Button } from '@consta/uikit/Button'
import type { FC } from 'react'

type FooterProps = {
  className?: string
  canConfirm: boolean
  isLoading: boolean
  onSave: () => void
}

export const Footer: FC<FooterProps> = ({ className, canConfirm, isLoading, onSave }) => {
  return (
    <Button
      size="xs"
      label="Рассчитать"
      disabled={!canConfirm}
      loading={isLoading}
      className={className}
      onClick={onSave}
    />
  )
}
